import { pickBy } from 'lodash';

export default pickBy;
